import { Grid, Typography, makeStyles, Link } from "@material-ui/core";
import { Box } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { StyledFooterLinkContainer } from "../LandingPage/Footer/StyledComponets";
import { useHistory } from "react-router";

const StyledLinkContainer = styled(Link)`
  font-size: 1em;
  cursor: pointer;
  &:hover: {
    color: blue;
  }
`;
const useStyles = makeStyles((theme) => ({
  link: {
    color: "white",
    background: "none",
    border: "none",
    outline: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));
const socials = [
  {
    url: "https://ds29nc3ljdjce.cloudfront.net/zipang/wechat.png",
    link: "https://ds29nc3ljdjce.cloudfront.net/zipang/weChat_QR.jpeg",
  },
  {
    url: "https://ds29nc3ljdjce.cloudfront.net/zipang/instagramicon.png",
    link: "https://www.instagram.com/zipangauctions/",
  },
  {
    url: "https://ds29nc3ljdjce.cloudfront.net/zipang/linkedin.png",
    link: "https://www.linkedin.com/company/zipang-auctions/posts/?feedView=all",
  },
  {
    url: "https://ds29nc3ljdjce.cloudfront.net/zipang/line logo.png",
    link: "https://line.me/R/ti/p/%40130eegeq",
  },
  {
    url: "https://ds29nc3ljdjce.cloudfront.net/zipang/fbicon.png",
    link: "https://www.facebook.com/zipangauctions",
  },
  {
    url: "https://ds29nc3ljdjce.cloudfront.net/zipang/whatsappicon.png",
    link: "https://api.whatsapp.com/message/DY37FMYCUSEJN1?autoload=1&app_absent=0",
  },
];
const StyledConinter = styled(Grid)`
  padding: 15px 20px;
  ${(props) => props.theme.breakpoints.between("xs", "md")} {
    text-align: center;
  }
`;

function Footer() {
  let { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  return (
    <>
      {" "}
      <Grid
        id="CONTACT"
        container
        style={{
          marginTop: "0.4em",
          background: "#d92b3c",
          color: "white",
        }}
      >
        <StyledConinter container xs={12} spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Typography style={{ textDecoration: "underline" }}>
              Japan office
            </Typography>

            <>
              <Typography className="fontLight">MJ Diamonds Co Ltd.</Typography>
              <Typography className="fontLight">
                {t("common:footer:officeAddress")}
              </Typography>
              <Typography className="fontLight">
                {t("common:footer:officeNumber")} |{" "}
                {t("common:footer:faxNumber")}
              </Typography>
            </>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography style={{ textDecoration: "underline" }}>
              Hongkong office
            </Typography>
            <>
              <Typography className="fontLight">
                Zipang Auctions HK Ltd.
              </Typography>
              <Typography className="fontLight">
                {t("common:footer:zipangofficeAddress")}
                <br />
                {t("common:footer:zipangofficeAddresssecond")}
                <br />
                {t("common:footer:zipangofficeAddressthird")}
                <br />
                {t("common:footer:zipangofficeNumber")}
                <br />
                <br />
                {t("common:footer:zipangofficeDPMsNumber")}
              </Typography>
            </>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography>Shobhit Suchanti</Typography>
            <>
              <Typography className="fontLight">+81-80552-47726</Typography>
            </>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "16px",
              }}
            >
              <Link
                className={classes.link}
                href={
                  /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
                    ? `mailto:${t("common:footer:emailId")}`
                    : `https://mail.google.com/mail/?view=cm&fs=1&to=${t(
                        "common:footer:emailId"
                      )}`
                }
                target="_blank"
                style={{ fontFamily: "Playfair Display" }}
              >
                <Typography> {t("common:footer:emailId")}</Typography>
              </Link>
              <Link
                className={classes.link}
                href="/termsandconditions"
                style={{ fontFamily: "Playfair Display" }}
              >
                {t("common:register:termsandCondition")}
              </Link>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Typography>Quick Links</Typography>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <StyledLinkContainer
                onClick={() => {
                  if (
                    window.location.pathname.includes("team-page") ||
                    window.location.pathname.includes("zipangAuctionslist") ||
                    window.location.pathname.slice(-4).toLocaleLowerCase() ===
                      "sell"
                  ) {
                    history.push("/zipang");
                  }
                  window.location.hash = "UPCOMMING";
                }}
              >
                {t("common:zipangLanding:tab:upcomingAuc")}
              </StyledLinkContainer>
              <StyledLinkContainer
                onClick={() => {
                  if (
                    window.location.pathname.includes("team-page") ||
                    window.location.pathname.includes("zipangAuctionslist") ||
                    window.location.pathname.slice(-4).toLocaleLowerCase() ===
                      "sell"
                  ) {
                    history.push("/zipang");
                  }
                  window.location.hash = "sell";
                }}
              >
                {t("common:zipangLanding:tab:sell")}
              </StyledLinkContainer>

              <StyledLinkContainer
                onClick={() => {
                  if (
                    window.location.pathname.includes("team-page") ||
                    window.location.pathname.slice(-4).toLocaleLowerCase() ===
                      "sell"
                  ) {
                    history.push("/zipang");
                  }
                  window.location.hash = "BUYER";
                }}
              >
                {t("common:zipangLanding:tab:buy")}
              </StyledLinkContainer>
              <StyledLinkContainer
                onClick={() => {
                  history.push("/team-page#OUR_TEAM_GRID");
                }}
              >
                {t("common:zipangLanding:tab:ourTeam")}
              </StyledLinkContainer>
              {/* <StyledLinkContainer
                onClick={() => {
                  // if (
                  //   window.location.pathname.includes("team-page") ||
                  //   window.location.pathname.slice(-4).toLocaleLowerCase() ===
                  //     "sell"
                  // ) {
                  //   history.push("/zipang");
                  // }

                  window.location.hash = "CONTACT";
                }}
              >
                {t("common:zipangLanding:tab:contact")}
              </StyledLinkContainer> */}
            </div>
          </Grid>

          {/* <Grid item xs={12} sm={6} md={2}>
            <Link
              className={classes.link}
              href={
                /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
                  ? `mailto:${t("common:footer:emailId")}`
                  : `https://mail.google.com/mail/?view=cm&fs=1&to=${t(
                      "common:footer:emailId"
                    )}`
              }
              target="_blank"
              style={{ fontFamily: "Playfair Display" }}
            >
              <Typography> {t("common:footer:emailId")}</Typography>
            </Link>
            <Link
              className={classes.link}
              href="/termsandconditions"
              style={{ fontFamily: "Playfair Display" }}
            >
              {t("common:register:termsandCondition")}
            </Link>
          </Grid> */}
        </StyledConinter>

        <div
          style={{
            textAlign: "center",
            width: "100%",
            fontSize: "1em",
            marginTop: "1em",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              gap: "5px",
              justifyContent: "center",
              fontWeight: 400,
              fontSize: "0.8em",
              alignItems: "center",
            }}
          >
            {socials.map((social, index) => {
              return (
                <p>
                  <a
                    target="_blank"
                    href={
                      index === 0
                        ? "https://ds29nc3ljdjce.cloudfront.net/zipang/weChat_QR.jpeg"
                        : social.link
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      alt="social"
                      src={social.url}
                      style={{
                        maxHeight:
                          index === 1 || index === 4 || index === 5
                            ? "4vh"
                            : "3vh",
                      }}
                    />
                  </a>
                </p>
              );
            })}
          </div>
        </div>
      </Grid>
    </>
  );
}

export default Footer;
